const STYLES: Record<string, { bg: string; fg: string; label: string }> = {
  critical: { bg: "hsl(0,70%,94%)", fg: "hsl(0,70%,40%)", label: "Critical" },
  high: { bg: "hsl(20,85%,92%)", fg: "hsl(20,85%,38%)", label: "High" },
  medium: { bg: "hsl(38,90%,92%)", fg: "hsl(32,90%,38%)", label: "Medium" },
  low: { bg: "hsl(210,16%,93%)", fg: "hsl(215,16%,40%)", label: "Low" },
};

export function MilestonePriorityBadge({ priority }: { priority: string }) {
  const s = STYLES[priority] ?? STYLES.medium;
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{ background: s.bg, color: s.fg }}
    >
      {s.label}
    </span>
  );
}
